import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-3",
  "use": "menu-3-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"menu-3\"><title>menu-3</title><path d=\"M12.44 10.63a1.08 1.08 0 0 0-.94.51l-2.2 3.71a.9.9 0 0 0 0 .93l2.2 3.71a1.08 1.08 0 0 0 .94.51h4.29a1.09 1.09 0 0 0 .94-.51l2.2-3.71a.91.91 0 0 0 0-.93l-2.2-3.71a1.08 1.08 0 0 0-.94-.51h-4.29zm4.09 7.1a.88.88 0 0 1-.74.4h-2.4a.88.88 0 0 1-.74-.39l-1.27-2a.73.73 0 0 1 0-.79l1.27-2a.88.88 0 0 1 .74-.39h2.4a.88.88 0 0 1 .74.39l1.27 2a.73.73 0 0 1 0 .79zm-8-12.22A1.08 1.08 0 0 0 7.56 5h-4.3a1.08 1.08 0 0 0-.93.51L.13 9.22a.9.9 0 0 0 0 .93l2.2 3.71a1.08 1.08 0 0 0 .93.51h4.3a1.08 1.08 0 0 0 .93-.51l2.2-3.71a.9.9 0 0 0 0-.93l-2.2-3.71zm8.24 3.87a1.08 1.08 0 0 0 .94-.51l2.2-3.71a.91.91 0 0 0 0-.93L17.67.51a1.08 1.08 0 0 0-.93-.51h-4.3a1.08 1.08 0 0 0-.94.51L9.31 4.22a.9.9 0 0 0 0 .93l2.2 3.71a1.08 1.08 0 0 0 .94.51h4.29zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-3.svg
// module id = aKJR
// module chunks = 6